import { Typography, Button } from "../../components"
import "./styles.css";

export default function OfferteAanvragen(props) {
    return (
        <div> Websitepagina in aanbouw. Stuur voor de offerte een mail naar info@centeringfeeding.com
        </div>
  );
}